module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 1.59422e-06 12.4183 1.20797e-06 8C8.21708e-07 3.58172 3.58172 -8.21708e-07 8 -1.20797e-06C12.4183 -1.59422e-06 16 3.58172 16 8Z",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.3605 4.49697C12.7222 4.87899 12.7222 5.49838 12.3605 5.88041L6.76514 11.7894L3.63996 8.48904C3.27822 8.10702 3.27822 7.48763 3.63996 7.1056C4.00171 6.72358 4.58822 6.72358 4.94997 7.1056L6.76514 9.02252L11.0505 4.49697C11.4122 4.11494 11.9987 4.11494 12.3605 4.49697Z",
      "fill": "white"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27ad44ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ad44ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/RedTickIcon.vue
// module id = 741
// module chunks = 0